import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, DebitCardIcon, NavigationLeftIcon, Text, useResponsive } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';
import { BackIcon } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/DirectDeposit/StyledComponents.styles';
import { DuplicationErrorModal } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/DublicationErrorModal/DuplicationErrorModal';
import theme from '@/styles/theme';

import { DebitCardForm } from './DebitCardForm';

const DESCRIPTION =
  'For faster access to your money, we will deposit your reimbursement on to your personal debit card.';

interface Props {
  onClose: () => void;
  onBack: () => void;
  onSuccess: () => void;
  hideNavigationButton?: boolean;
  allowSaveAsDefault?: boolean;
}

export const DebitCardModal: React.FC<Props> = ({
  onClose,
  onBack,
  onSuccess,
  hideNavigationButton,
  allowSaveAsDefault,
}) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const [serverErrorShow, setServerErrorShow] = useState(false);

  return (
    <ModalWrapper
      visible
      contentStyle={{
        maxWidth: '718px',
        padding: isMobile ? `${theme.spacings.spacing24} ${theme.spacings.spacing16}` : undefined,
      }}
      onSetVisible={onClose}
      testId="AddDebitCard"
    >
      {onBack && !hideNavigationButton && !isMobile && (
        <BackIcon onClick={onBack} data-testid="back-icon-button">
          <NavigationLeftIcon color="iconPrimary" size="18px" />
        </BackIcon>
      )}

      <Box align="center">
        <Box width="xxsmall" alignSelf="center" data-testid="DebitCard_icon">
          <DebitCardIcon size="32px" color="iconAccent" />
        </Box>

        <Text
          size="2xl"
          weight="bold"
          textAlign="center"
          color="textBody"
          margin={{ top: isMobile ? 'spacing12' : 'spacing20' }}
        >
          {t('My Personal Debit Card')}
        </Text>

        <Text
          size={isMobile ? 'large' : 'medium'}
          textAlign="center"
          color="textBody"
          margin={{ top: 'spacing12', bottom: 'spacing24' }}
        >
          {t(DESCRIPTION)}
        </Text>
      </Box>

      <DebitCardForm
        onBack={onBack}
        onSuccess={onSuccess}
        onError={() => setServerErrorShow(true)}
        allowSaveAsDefault={allowSaveAsDefault}
      />
      <DuplicationErrorModal visible={serverErrorShow} close={() => setServerErrorShow(false)} />
    </ModalWrapper>
  );
};
